import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { OscUtilsModule } from '@osc-utils/osc-utils.module';
import { components } from './components';
import { materialModules } from './material';

@NgModule({
  imports: [CommonModule, ...materialModules, OscUtilsModule, SharedModule, ...components],
  exports: [...components],
})
export class ReportSharedModule {}
